module.exports = __webpack_public_path__ + "img/Emails.e4052bea.jpeg";